import { useState } from 'react';

import { Box } from '@zillow/constellation-10';

import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

import { useIdentityVerification } from '../../hooks/useIdentityVerification';

import { getBannerContent } from './content';
import IdentityVerificationAlert from './IdentityVerificationAlert';

import type { IdentityVerificationStatus } from '../../types/identityVerification';

/** Account-wide IDV status. Not dismissible while its CTA resolves it. */
const IdentityVerificationPageAlert = () => {
  const verification = useIdentityVerification();
  const [dismissedStatus, setDismissedStatus] = useState<IdentityVerificationStatus>();

  const content = getBannerContent(verification, Date.now());
  const status = verification.entry?.status;

  if (!content || (content.isDismissible && dismissedStatus === status)) return null;

  return (
    // Rendered above Page.Content, so it repeats the page's width and gutters like bannerBoxRecipe.
    <Box
      css={{
        boxSizing: 'content-box',
        maxWidth: 'breakpoint-xxl',
        marginBlock: 'default',
        marginInline: 'auto',
        paddingInline: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
      }}
    >
      <IdentityVerificationAlert
        content={content}
        onClose={content.isDismissible ? () => setDismissedStatus(status) : undefined}
        testId="IdentityVerificationBanner"
      />
    </Box>
  );
};

// Its own boundary, so bad verification data hides the banner instead of breaking the page.
const IdentityVerificationBanner = () => (
  <RpErrorBoundary fallback={<></>}>
    <IdentityVerificationPageAlert />
  </RpErrorBoundary>
);

export default IdentityVerificationBanner;
